<template>
  <div>
    <div>
      <nav class="navbar navbar-expand-lg fixed-top navbar-light" style="max-height: 64px; background-color: #FFF;">
        <!-- <div class="container">  -->
        <a class="navbar-brand" href="#">
          <img class="img-fluid d-block" src="img/logo-tribanco.png" width="120px" v-if="
            [8, 22].includes(Number(envOwnerId)) ||
            (Array.isArray(envOwnerId) &&
              envOwnerId.map(Number).some((id) => [8, 22].includes(id)))
          ">
          <img class="img-fluid d-block" src="img/logo-tricard.png" width="120px" v-else>
        </a>
        <div class="collapse navbar-collapse" id="navbar5">
          <ul class="navbar-nav ml-auto text-center">
          </ul>
        </div>
        <!-- </div> -->
      </nav>
      <!-- <nav class="navbar navbar-expand-lg navbar-light fixed-top">
        <div class="container">
          <a class="navbar-brand" href="/">
            <img
              class="img-fluid d-block w-100"
              src="/img/logo.png"
            />
          </a>
        </div>
      </nav> -->
      <flash-message transitionIn="animated swing" class="alert-system"></flash-message>
    </div>

    <div>
      <Login></Login>
    </div>

    <div>
      <div class="footer1" style="">
        <div class="container">
          <div class="row align-items-center pt-lg-2 pt-4">
            <div class="row col justify-content-around">
              <div>
                <h5><b>Tricard</b></h5>
                <ul class="list-unstyled">
                  <li><a href="/" style="color: #1641cc">Home</a></li>
                  <router-link v-for="link in footerlinks" :key="link.text" :to="{}"
                    @click.native="redirectPolitica(link, 'tricard')">
                    <li>
                      <a style="color: #1641cc">{{ link.text }}</a>
                    </li>
                  </router-link>
                </ul>
              </div>
              <div>
                <h5><b>Tribanco</b></h5>
                <ul class="list-unstyled">
                  <li><a href="/" style="color: #1641cc">Home</a></li>
                  <router-link v-for="link in footerlinks" :key="link.text" :to="{}"
                    @click.native="redirectPolitica(link, 'tribanco')">
                    <li>
                      <a target="_blank" style="color: #1641cc">{{ link.text }}
                      </a>
                    </li>
                  </router-link>
                </ul>
              </div>
            </div>
            <div class="row col justify-content-center">
              <div>
                <p class="mb-0">Tricard | Fale conosco:</p>
                <a @click="saveLogcontatoPhone(ownerAlias = 'Tricard')" class="btn btn-link"
                  href="tel:+5508007223099"><i class="fa fa-phone fa-fw mx-1 fa-lg"></i>0800 722 3099</a><a
                  @click="openWhats(ownerAlias = 'Tricard')" class="btn btn-link"
                  href="https://api.whatsapp.com/send?l=pt&amp;phone=551130033099" target="_blank"><i
                    class="fa fa-whatsapp fa-fw mx-1 fa-lg"></i>(11) 3003-3099</a>
                <hr />
              </div>
              <div>
                <p class="mb-0">Tribanco | Fale conosco:</p>
                <a @click="saveLogcontatoPhone(ownerAlias = 'Tribanco')" class="btn btn-link"
                  href="tel:+5508009793355"><i class="fa fa-phone fa-fw mx-1 fa-lg"></i>0800 979 3355</a><a
                  @click="openWhats(ownerAlias = 'Tribanco')" class="btn btn-link"
                  href="https://api.whatsapp.com/send?l=pt&amp;phone=553430033366" target="_blank"><i
                    class="fa fa-whatsapp fa-fw mx-1 fa-lg"></i>(34) 3003-3366</a>
                <hr />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-center">
              <p class="mb-1">@tribanco | tricard</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Login from "@/modules/auth/Login";
export default {
  name: "Home",
  components: {
    Login,
  },
  data: () => ({
    hrefwhatsapp: "https://api.whatsapp.com/send?l=pt&phone=551132303765",
    footerlinks: [
      { icon: "", text: "Quem Somos", route: "somos" },
      {
        icon: "",
        text: "Termos de uso",
        route: "termos_tribanco",
        params: "Termos de uso",
      },
      {
        icon: "",
        text: "Política de privacidade",
        route:
          "https://www.tribanco.com.br/seg-corporativa/politica-de-privacidade/",
        params: "Política de privacidade",
      },
    ],
    footerlinksc: [
      { icon: "", text: "Quem Somos", route: "somos" },
      {
        icon: "",
        text: "Termos de uso",
        route: "termos_tricard",
        params: "Termos de uso",
      },
      {
        icon: "",
        text: "Política de privacidade",
        route:
          "https://www.tribanco.com.br/seg-corporativa/politica-de-privacidade/",
        params: "Política de privacidade",
      },
    ],
    largura: null,
    ipUser: null,
    envOwnerId: process.env.VUE_APP_OWNER_ID,
  }),
  methods: {
    ...mapActions("auth", [
      "ActionGetWhatsText",
      "ActionSendLogWhatsappWithoutToken",
      "ActionLogContato",
    ]),

    async saveLogcontatoPhone(ownerAlias) {
      this.ipUser = localStorage.getItem("ipUser");
      this.ActionLogContato({
        DocNumber: localStorage.getItem("doc") ?? null,
        tag: "Padrao",
        ownerAlias: ownerAlias,
        contactType: "Telefone",
        IP: this.ipUser ? this.ipUser : "",
        OS: navigator.platform,
      });
    },

    async openWhats(ownerAlias) {
      this.ipUser = localStorage.getItem("ipUser");
      if (this.user != null) {
        var resp = await this.ActionGetWhatsText({
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });
        console.log("resp: " + JSON.stringify(resp));
      } else {
        console.log("registrando log...");
        await this.ActionSendLogWhatsappWithoutToken({
          ValueId: 16,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });
        console.log("log registrado.");
      }

      this.ActionLogContato({
        DocNumber: localStorage.getItem("doc") ?? null,
        tag: "Padrao",
        ownerAlias: ownerAlias,
        contactType: "WhatsApp",
        IP: this.ipUser ? this.ipUser : "",
        OS: navigator.platform,
      });
    },

    redirectPolitica(link, banco) {
      if (link.route.includes("https://")) {
        window.open(link.route, "_blank").focus();
      } else {
        this.$router.push({
          name: link.route,
          query: { title: link.text, banco },
        });
      }
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
  created() {
    this.largura = window.screen.width;
  },
};
</script>
<style>
i,
a {
  color: #1641cc;
}
</style>
